import React, { useEffect, useState } from "react";
import { fileUrl } from "@/lib/api";
import { getLocalPhoto } from "@/lib/offline";

export const PhotoImg = ({ photo, className, onOpen, testId }) => {
  const [src, setSrc] = useState(photo.storage_path ? fileUrl(photo.storage_path) : null);

  useEffect(() => {
    if (photo.storage_path || !photo.local_id) { setSrc(photo.storage_path ? fileUrl(photo.storage_path) : null); return undefined; }
    let url = null;
    getLocalPhoto(photo.local_id).then((b) => { if (b) { url = URL.createObjectURL(b); setSrc(url); } });
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [photo.storage_path, photo.local_id]);

  if (!src) return <div className={`${className} bg-slate-100 dark:bg-slate-800`} />;
  return <img src={src} alt="chantier" data-testid={testId} className={className} onClick={onOpen ? () => onOpen(src) : undefined} />;
};
